module.exports = __webpack_public_path__ + "img/1.ea1fef03.png";